import { Link } from "react-router-dom";
import { films, getFilmById } from "@/lib/films";

const chart = [...films].sort((a, b) => b.heat - a.heat).slice(0, 8);
const promo = getFilmById("paper-moon-club");

export default function TopChart() {
  return (
    <section className="w-full border-y border-background-300 bg-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-8 md:py-16 lg:px-12">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.45fr_1fr] lg:gap-10">
          <div>
            <div className="flex flex-wrap items-end justify-between gap-3">
              <div>
                <p className="font-label text-[11px] uppercase tracking-[0.28em] text-accent-500">Weekly chart</p>
                <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">站内热度榜</h2>
              </div>
              <span className="font-label text-xs text-foreground-500">按本周浏览与收藏综合排序</span>
            </div>

            <ol className="mt-6 divide-y divide-background-300/80 border-y border-background-300/80">
              {chart.map((film, index) => (
                <li key={film.id}>
                  <Link
                    to={`/detail/${film.id}`}
                    className="group flex items-center gap-3 py-3 transition-colors hover:bg-background-200/60 md:gap-4 md:px-2"
                  >
                    <span
                      className={`w-7 shrink-0 font-heading text-lg font-bold tabular-nums ${
                        index < 3 ? "text-accent-500" : "text-foreground-500"
                      }`}
                    >
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <span className="relative h-16 w-11 shrink-0 overflow-hidden rounded border border-background-300">
                      <img
                        src={film.poster}
                        alt={`《${film.title}》榜单缩略海报`}
                        title={`${film.title} 海报`}
                        className="h-full w-full object-cover object-top"
                      />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate font-heading text-sm font-semibold text-foreground-900 transition-colors group-hover:text-accent-500 md:text-base">
                        {film.title}
                      </span>
                      <span className="mt-1 block truncate font-label text-[11px] text-foreground-500">
                        {film.year} · {film.director} · {film.genres.join(" / ")}
                      </span>
                    </span>
                    <span className="hidden shrink-0 items-center gap-1 font-label text-xs text-foreground-500 sm:flex">
                      <i className="ri-fire-line text-accent-500" />
                      {film.heat}
                    </span>
                    <i className="ri-arrow-right-s-line shrink-0 text-base text-foreground-500" />
                  </Link>
                </li>
              ))}
            </ol>
          </div>

          {promo && (
            <aside className="relative overflow-hidden rounded-lg border border-background-300">
              <img
                src={promo.backdrop ?? promo.poster}
                alt={`《${promo.title}》导演专题配图`}
                title={`${promo.title} 导演专题`}
                className="absolute inset-0 h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/85 to-background-50/30" />
              <div className="relative flex h-full min-h-[420px] flex-col justify-end p-6 md:p-8">
                <span className="w-fit rounded-full bg-accent-500 px-3 py-1 font-label text-[11px] text-background-50">
                  导演专题
                </span>
                <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  同一位导演，
                  <br />
                  反复书写的同一个命题
                </h3>
                <p className="mt-3 max-w-sm font-body text-sm leading-relaxed text-foreground-600">
                  按创作者线索整理片单，能更快看出风格如何演变——从早期的长镜头克制，到近作对空间与光线的强调。
                </p>
                <div className="mt-6 flex flex-wrap items-center gap-3">
                  <Link
                    to="/category?type=auteur"
                    className="flex h-10 items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 font-label text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
                  >
                    查看导演专题
                    <i className="ri-arrow-right-line" />
                  </Link>
                  <Link
                    to={`/detail/${promo.id}`}
                    className="font-label text-xs text-foreground-700 transition-colors hover:text-accent-500"
                  >
                    代表作品：《{promo.title}》
                  </Link>
                </div>
              </div>
            </aside>
          )}
        </div>
      </div>
    </section>
  );
}